import PublicLobbyGetLobbyType from "../../quickServices/PublicLobbyGetLobbyType";
import useSWR from 'swr';
export let LobbyType = /*#__PURE__*/function (LobbyType) {
  LobbyType[LobbyType["Multi"] = 1] = "Multi";
  LobbyType[LobbyType["Single_Session"] = 2] = "Single_Session";
  LobbyType[LobbyType["Single_Stage"] = 3] = "Single_Stage";
  return LobbyType;
}({});
/**
 * 查询 lobby type
 */
export default function useLobbyType(params, http) {
  const {
    data = {
      lobbyType: 1,
      lobbyLiveEnable: false
    }
  } = useSWR({
    url: '/v2/activities/public/lobby/get-lobby-type',
    params
  }, async ({
    params
  }) => {
    const res = await PublicLobbyGetLobbyType(params, http);
    let type = 1;
    let liveEnable = false;
    if (res.code === 0) {
      type = res.data.type || 1;
      liveEnable = res.data.live_enable || false;
    }
    return {
      lobbyType: type,
      lobbyLiveEnable: liveEnable
    };
  }, {
    revalidateOnFocus: false
  });
  return data;
}